import React from 'react';
import ContentLoader from 'react-content-loader';
import './SkeletonScreen.css';

export function sessionsTableSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="tableContentLoader">
      <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
    </ContentLoader>
  );
}

export function mobileTableSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileTableContentLoader">
      <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
    </ContentLoader>
  );
}

export function virtualEventsTableSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="tableContentLoader">
      <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
    </ContentLoader>
  );
}

export function mobileVirtualEventsTableSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileTableContentLoader">
      <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
    </ContentLoader>
  );
}

export function showGenericSkeletonScreen(isBig) {
  if (isBig === false) {
    return (
      <ContentLoader
        height={384}
        width="100%"
        speed={2}
        primaryColor={'#f0f0f0'}
        secondaryColor={'#e9e9e9'}
        className="genericContentLoader">
        <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
        <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
        <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
      </ContentLoader>
    );
  }
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="genericContentLoader">
      <rect x="0" y="24" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="80" rx="0" ry="0" width="1283" height="32" />
      <rect x="0" y="136" rx="0" ry="0" width="1283" height="32" />
    </ContentLoader>
  );
}

export function chartSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="chartContentLoader">
      <rect x="0" y="190" rx="0" ry="0" width="24" height="194" />
      <rect x="28" y="256" rx="0" ry="0" width="24" height="128" />
      <rect x="80" y="134" rx="0" ry="0" width="24" height="250" />
      <rect x="108" y="178" rx="0" ry="0" width="24" height="206" />
      <rect x="160" y="204" rx="0" ry="0" width="24" height="180" />
      <rect x="188" y="232" rx="0" ry="0" width="24" height="152" />
      <rect x="240" y="97" rx="0" ry="0" width="24" height="287" />
      <rect x="268" y="233" rx="0" ry="0" width="24" height="151" />
      <rect x="320" y="201" rx="0" ry="0" width="24" height="183" />
      <rect x="348" y="287" rx="0" ry="0" width="24" height="97" />

      <rect x="400" y="170" rx="0" ry="0" width="24" height="214" />
      <rect x="428" y="229" rx="0" ry="0" width="24" height="155" />
      <rect x="480" y="115" rx="0" ry="0" width="24" height="269" />
      <rect x="508" y="224" rx="0" ry="0" width="24" height="160" />
      <rect x="560" y="172" rx="0" ry="0" width="24" height="212" />
      <rect x="588" y="257.9" rx="0" ry="0" width="24" height="126.1" />
      <rect x="640" y="130" rx="0" ry="0" width="24" height="254" />
      <rect x="668" y="232.9" rx="0" ry="0" width="24" height="151.1" />
      <rect x="720" y="147" rx="0" ry="0" width="24" height="237" />
      <rect x="748" y="243" rx="0" ry="0" width="24" height="141" />
    </ContentLoader>
  );
}

export function mobileChartSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileChartContentLoader">
      <rect x="0" y="190" rx="0" ry="0" width="12" height="194" />
      <rect x="28" y="256" rx="0" ry="0" width="12" height="128" />
      <rect x="80" y="134" rx="0" ry="0" width="12" height="250" />
      <rect x="108" y="178" rx="0" ry="0" width="12" height="206" />
      <rect x="160" y="204" rx="0" ry="0" width="12" height="180" />
      <rect x="188" y="232" rx="0" ry="0" width="12" height="152" />
      <rect x="240" y="97" rx="0" ry="0" width="12" height="287" />
      <rect x="268" y="233" rx="0" ry="0" width="12" height="151" />
      <rect x="300" y="201" rx="0" ry="0" width="12" height="183" />
      <rect x="328" y="287" rx="0" ry="0" width="12" height="97" />
    </ContentLoader>
  );
}

export function overViewSkeletonScreen() {
  return (
    <ContentLoader
      height={384}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="overviewContentLoader">
      <rect x="0" y="21" rx="0" ry="0" width="132" height="16" />
      <rect x="0" y="45" rx="0" ry="0" width="82" height="16" />
      <rect x="0" y="142" rx="0" ry="0" width="132" height="16" />
      <rect x="0" y="166" rx="0" ry="0" width="82" height="16" />
      <rect x="0" y="263" rx="0" ry="0" width="132" height="16" />
      <rect x="0" y="287" rx="0" ry="0" width="82" height="16" />
    </ContentLoader>
  );
}

export function tableStatSkeletonScreen() {
  return (
    <ContentLoader
      height={300}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="tableStatContentLoader">
      <rect x="0" y="100" rx="0" ry="0" width="132" height="26" />
      <rect x="144" y="100" rx="0" ry="0" width="132" height="26" />
      <rect x="1120" y="100" rx="0" ry="0" width="132" height="26" />
    </ContentLoader>
  );
}

export function mobileTableStatSkeletonScreen() {
  return (
    <ContentLoader
      height={100}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileTableStatContentLoader">
      <rect x="0" y="21" rx="0" ry="0" width="64" height="12" />
      <rect x="80" y="21" rx="0" ry="0" width="64" height="12" />
      <rect x="200" y="21" rx="0" ry="0" width="64" height="12" />
    </ContentLoader>
  );
}

export function mobileHeaderSkeletonScreen() {
  return (
    <ContentLoader
      height={100}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileHeaderContentLoader">
      <rect x="0" y="21" rx="0" ry="0" width="64" height="12" />
      <rect x="0" y="45" rx="0" ry="0" width="132" height="12" />
    </ContentLoader>
  );
}

export function mobileOverviewSkeletonScreen() {
  return (
    <ContentLoader
      height={100}
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileOverviewContentLoader">
      <rect x="0" y="21" rx="0" ry="0" width="44" height="12" />
      <rect x="0" y="45" rx="0" ry="0" width="20" height="12" />
      <rect x="90" y="21" rx="0" ry="0" width="44" height="12" />
      <rect x="90" y="45" rx="0" ry="0" width="20" height="12" />
      <rect x="180" y="21" rx="0" ry="0" width="44" height="12" />
      <rect x="180" y="45" rx="0" ry="0" width="20" height="12" />
    </ContentLoader>
  );
}

export function desktopSkeletonScreen() {
  return (
    <ContentLoader
      height="100%"
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="desktopSkeletonScreen">
      <path d="M8 508.9h32v286.058H8z" />
      <rect width="32" height="188.739" x="47.052" y="606.219" rx="3" />
      <rect width="32" height="368.63" x="120.818" y="426.327" rx="3" />
      <rect width="32" height="303.751" x="159.87" y="491.206" rx="3" />
      <rect width="32" height="265.414" x="233.635" y="529.544" rx="3" />
      <rect width="32" height="224.127" x="272.688" y="570.83" rx="3" />
      <rect width="32" height="269.837" x="459.271" y="525.12" rx="3" />
      <rect width="32" height="143.028" x="498.323" y="651.929" rx="3" />
      <rect width="32" height="315.547" x="572.088" y="479.41" rx="3" />
      <path d="M611.14 566.407h32v228.55h-32z" />
      <rect width="32" height="396.646" x="684.906" y="398.312" rx="3" />
      <path d="M723.958 558.978h32v235.98h-32z" />
      <rect width="32" height="312.598" x="797.724" y="482.359" rx="3" />
      <rect width="32" height="185.976" x="836.776" y="608.981" rx="3" />
      <rect width="32" height="374.528" x="910.541" y="420.429" rx="3" />
      <path d="M949.594 572.137h32v222.82h-32z" />
      <rect width="32" height="349.461" x="1023.359" y="445.496" rx="3" />
      <rect width="32" height="207.907" x="1062.411" y="587.05" rx="3" />
      <rect width="32" height="423.187" x="346.453" y="371.77" rx="3" />
      <rect width="32" height="222.653" x="385.505" y="572.305" rx="3" />
      <rect width="126.3" height="32" x="8" y="890" rx="2" />
      <rect width="126.3" height="32" x="145.975" y="890" rx="2" />
      <rect width="126.3" height="32" x="970.639" y="890" rx="2" />
      <rect width="1090" height="32" x="8" y="940" rx="2" />
      <rect width="1090" height="32" x="8" y="996" rx="2" />
      <rect width="1090" height="32" x="8" y="1052" rx="2" />
      <rect width="206" height="32" y="101" rx="2" />
      <rect width="206" height="32" y="2" rx="2" />
      <rect width="127" height="32" y="144" rx="2" />
      <rect width="206" height="32" x="283" y="101" rx="2" />
      <rect width="127" height="32" x="283" y="144" rx="2" />
      <rect width="206" height="32" x="566" y="101" rx="2" />
      <rect width="127" height="32" x="566" y="144" rx="2" />
      <rect width="206" height="32" x="849" y="101" rx="2" />
      <rect width="127" height="32" x="849" y="144" rx="2" />
      <rect width="146" height="32" x="957" rx="2" />
      <rect width="90" height="32" x="859" rx="2" />
      <rect width="283" height="32" y="254" rx="2" />
      <rect width="283" height="32" x="378" y="254" rx="2" />
      <rect width="283" height="32" x="772" y="254" rx="2" />
    </ContentLoader>
  );
}

export function mobileSkeletonScreen() {
  return (
    <ContentLoader
      height="100%"
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="mobileSkeletonScreen">
      <rect width="42" height="22.347" y="166" rx="2" />
      <rect width="109" height="22.347" y="195.796" rx="2" />
      <rect width="42" height="22.347" x="141" y="166" rx="2" />
      <rect width="109" height="22.347" x="141" y="195.796" rx="2" />
      <rect width="42" height="22.347" x="282" y="166" rx="2" />
      <rect width="109" height="22.347" x="282" y="195.796" rx="2" />
      <rect width="103" height="22" rx="2" />
      <rect width="166" height="22" y="58" rx="2" />
      <rect width="64" height="22" y="96" rx="2" />
      <rect width="317" height="48" y="307" rx="2" />
      <rect width="318" height="24" y="371" rx="2" />
      <rect width="256" height="24" y="267" rx="2" />
      <rect width="317" height="48" y="483" rx="2" />
      <rect width="318" height="24" y="547" rx="2" />
      <rect width="256" height="24" y="443" rx="2" />
      <rect width="317" height="48" y="659" rx="2" />
      <rect width="318" height="24" y="723" rx="2" />
      <rect width="256" height="24" y="619" rx="2" />
      <rect width="37" height="24" y="795" rx="2" />
      <rect width="37" height="24" x="45" y="795" rx="2" />
      <rect width="37" height="24" x="281" y="795" rx="2" />
      <rect width="318" height="24" y="835" rx="2" />
      <rect width="318" height="24" y="875" rx="2" />
      <rect width="318" height="24" y="915" rx="2" />
    </ContentLoader>
  );
}

export function attendeesInSessionDesktopSkeletonScreen() {
  return (
    <ContentLoader
      height="100%"
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="attendeesInSessionDesktopSkeletonScreen">
      <rect width="256" height="32" x="16" y="16" rx="2" />
      <rect width="538" height="96" x="16" y="64" rx="2" />
      <rect width="540" height="48" x="16" y="176" rx="2" />
      <rect width="540" height="48" x="16" y="240" rx="2" />
    </ContentLoader>
  );
}

export function sessionsDetailsDesktopSkeletonScreen() {
  return (
    <ContentLoader
      height="100%"
      width="100%"
      speed={2}
      primaryColor={'#f0f0f0'}
      secondaryColor={'#e9e9e9'}
      className="sessionsDetailsDesktopSkeletonScreen">
      <rect width="126" height="32" x="8" y="1186" rx="2" />
      <rect width="126" height="32" x="146" y="1186" rx="2" />
      <rect width="126" height="32" x="971" y="1186" rx="2" />
      <rect width="1090" height="48" x="8" y="1234" rx="2" />
      <rect width="1090" height="48" x="8" y="1298" rx="2" />
      <rect width="538" height="96" y="421" rx="2" />
      <rect width="540" height="48" y="533" rx="2" />
      <rect width="256" height="32" y="373" rx="2" />
      <rect width="538" height="96" x="564" y="421" rx="2" />
      <rect width="540" height="48" x="564" y="533" rx="2" />
      <rect width="256" height="32" x="564" y="373" rx="2" />
      <rect width="707" height="96" y="949" rx="2" />
      <rect width="710" height="45" y="1061" rx="2" />
      <rect width="540" height="32" y="901" rx="2" />
      <rect width="540" height="32" y="661" rx="2" />
      <rect width="1106" height="48" y="709" rx="2" />
      <rect width="1106" height="48" y="773" rx="2" />
      <rect width="369.989" height="96" x="734" y="949" rx="2" />
      <rect width="372" height="45" x="734" y="1061" rx="2" />
      <rect width="177.957" height="32" x="734" y="901" rx="2" />
      <rect width="1090" height="48" x="8" y="1362" rx="2" />
      <rect width="332" height="32" y="82" rx="2" />
      <rect width="206" height="32" y="2" rx="2" />
      <rect width="127" height="32" y="125" rx="2" />
      <rect width="146" height="32" x="957" rx="2" />
      <rect width="258" height="96" y="197" rx="2" />
      <rect width="258" height="96" x="282" y="197" rx="2" />
      <rect width="258" height="96" x="564" y="197" rx="2" />
      <rect width="258" height="96" x="846" y="197" rx="2" />
    </ContentLoader>
  );
}



// WEBPACK FOOTER //
// ./src/SkeletonScreens/SkeletonScreen.js